<div id="page-container">
  <div id="content-wrap" *ngIf="pollData && pollData.type == 'list'">
    <headband></headband>

    <div style="display: grid; grid-template-columns: 15% 70% 15%" class="h-full">
      <div id="logo-panel" style="padding-top: 50px">
        <img src="assets/v8te.png" id="logo" data-cy="back-btn" (click)="navigateHome()">
      </div>
      <main id="main-panel" class="bg-pastel-blue" style="padding: 60px 20px 20px 20px">

        <app-cse-header [pollData]="pollData" [startDate]="startDate" [endDate]="endDate"
          (downloadResultsAction)="downloadDocuments()" (goToAuditPageAction)="navigateToAudit()"
          (downloadRepresentationAction)="downloadRepresentation()" [assessorsValidated]="assessorsValidated"
          (downloadCerfaAction)="downloadCerfa()" [inactiveAssessors]="remainingAssessors" [assessorCount]="assessors"
          (missingAssessorsAction)="getRemainingAssessors()" [canResendAssessors]="canResendAssessors"
          (relaunchAssessorsAction)="relaunchAssessors()" (teletransmission)="sendTelTrans()"></app-cse-header>
        <div class="flex gap-10 mt-20">
          <v8te-active-button *ngIf="pollData.colleges.length >= 1" [buttonText]='pollData.colleges[0].displayName'
            [height]="50" (click)="selectCollege(1)" [active]="selectedCollege == 1"
            [cursor]="'pointer'"></v8te-active-button>
          <v8te-active-button *ngIf="pollData.colleges.length >= 2" [buttonText]='pollData.colleges[1].displayName'
            [height]="50" (click)="selectCollege(2)" [active]="selectedCollege == 2"
            [cursor]="'pointer'"></v8te-active-button>
          <v8te-active-button *ngIf="pollData.colleges.length >= 3" [buttonText]='pollData.colleges[2].displayName'
            [height]="50" (click)="selectCollege(3)" [active]="selectedCollege == 3"
            [cursor]="'pointer'"></v8te-active-button>
        </div>

        <div class="flex gap-10 mt-20 bg-white p-10 radius-10 w-fit mb-20">
          <v8te-active-button *ngFor="let item of pollData.rounds; let i = index" [buttonText]="item.title"
            [hidden]="item.college != selectedCollege" [active]="i == activeElectionToDisplay" [height]="50"
            [width]="204" [icon]="'assets/college-icon.svg'" [iconPosition]="'left'"
            (click)="setActiveElectionToDisplay(i)" [cursor]="'pointer'"></v8te-active-button>
        </div>

        <app-cse-results [pollData]="pollData" [votes]="pollData.rounds[activeElectionToDisplay].votes"
          [results]="resultsToDisplay" [blockchainLink]="blockchainLink"
          [cseRoundResult]="pollData.rounds[activeElectionToDisplay].cseResults"
          [activeElectionToDisplay]="activeElectionToDisplay"></app-cse-results>


        <div class="radius-10 bg-white mt-20">
          <div class="p-20" style="border-bottom: solid 1px #DCEEFF;">
            <div class="flex gap-10 align-items-center mb-10 content-between">
              <div class="flex gap-10 align-items-center">
                <img src="assets/member-icon.svg" alt="">
                <h1 class="dark-blue text-lg no-margin">Listes et candidats</h1>
              </div>
              <div class="w-20 text-right">
                <h1 class="text-sm no-margin mb-10 green2">
                  LDL {{electedCount}}/{{pollData.rounds[activeElectionToDisplay].seats}} sièges à pourvoir
                </h1>
                <p-progressBar [value]="(electedCount / pollData.rounds[activeElectionToDisplay].seats) * 100"
                  [showValue]="false"></p-progressBar>
              </div>

            </div>

          </div>
          <div *ngFor="let list of resultsToDisplay; let i = index" class="p-20">
            <div class="radius-10" style="border: solid 1px #DCEEFF">
              <div class="p-20 flex content-between" style="border-bottom: solid 1px #DCEEFF;">
                <div class="flex gap-10 align-items-center">
                  <img *ngIf="list.listIcon" width="40" src="{{list.listIcon}}" alt="list icon">
                  <h1 class="dark-blue no-margin text-md">{{list.listName}}</h1>
                </div>
                <div class="flex gap-10">
                  <p class="dark-blue no-margin text-md bold">{{results[0][i]}} voix</p>
                  <span style="color: #DCEEFF;" *ngIf="i != resultsToDisplay.length - 1">|</span>
                  <p class="dark-blue no-margin text-md" *ngIf="i != resultsToDisplay.length - 1"><span class="bold">{{
                      list.electedCount }}</span> sièges obtenus</p>
                </div>
              </div>
              <div class="p-20 flex flex-column gap-10" *ngIf="list.listName != 'Vote blanc'">
                <div *ngFor="let candidate of list.candidateNames; let index = index">
                  <div class="flex content-between radius-10 p-10 align-items-center"
                    [class.bg-pastel-green]="list.elected[index]"
                    [style.border]="list.elected[index] ? 'solid 1px #63BA67' : 'solid 1px #DCEEFF'">
                    <div class="flex gap-10 align-items-center">
                      <img width="40" src="assets/valid-square-icon.svg" alt="candidate icon"
                        *ngIf="list.elected[index]">
                      <img width="40" src="{{list.candidateIcons[index]}}" alt="candidate icon"
                        *ngIf="list.candidateIcons && list.candidateIcons.length > 0 && list.candidateIcons[index] else defaultCandidateIcon">
                      <ng-template #defaultCandidateIcon>
                        <img width="40"
                          [src]="candidate.startsWith('M.') ? 'assets/man-icon.svg' : 'assets/woman-icon.svg'"
                          alt="candidate icon" *ngIf="candidate">
                      </ng-template>



                      <p class="dark-blue no-margin text-md bold">
                        {{candidate}}
                      </p>

                      <app-custom-tag [isValidated]="list.elected[index]"
                        [text]="candidate.startsWith('M.') ? 'Élu' : 'Élue'"></app-custom-tag>
                    </div>

                    <div>
                      <div class="flex gap-10 align-items-end">
                        <p class="dark-blue no-margin text-md">{{list.results[index][0]}} voix</p>
                        <p class="dark-blue no-margin text-sm">({{results[0][i] - list.results[index][0]}} ratures)</p>
                      </div>
                      <div class="dark-blue no-margin text-sm text-right">
                        {{(pollData.rounds[activeElectionToDisplay].votes - resultsToDisplay[resultsToDisplay.length -
                        1].results[0][0]) > 0 ? (list.results[index][0] /
                        (pollData.rounds[activeElectionToDisplay].votes - resultsToDisplay[resultsToDisplay.length -
                        1].results[0][0]) * 100 | number:'1.0-2') + '%' : '0%'}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </main>

    </div>


  </div>
  <div id="content-wrap" *ngIf="pollData && pollData.type != 'list'">
    <vc-poll-pages-header [title]="title" [shouldReturnToPoll]="false" [pollId]="pollId" [isLive]="isLive"
      [isPublic]="isPublic" [SMSOption]="SMSOption" [is2FA]="is2FA" [isAssessors]="hasAssessors">
    </vc-poll-pages-header>
    <div *ngIf="pollData != null">
      <vc-poll-finished-summary [description]="description" [startDate]="startDate" [endDate]="endDate"
        [votersCount]="votersCount" (displayVoters)="receiveVoterMessage($event)" [votersVoted]="votes"
        [participation]="percentageString" (downloadVoters)="downloadDocuments()" (shareResults)="shareResults()"
        [resultsShared]="resultsShared" [isShareEnabled]="isShareEnabled" [endDateFormat]="endDateFormat"
        (return)="rejoinPoll()" [participants]="pollData.attendance" [type]="votingType" [calculating]="calculating"
        [isActive]="isActive" [displayDownload]="displayIndex == -1" [live]="isLive" [quorum]="pollData.quorum">
      </vc-poll-finished-summary>
    </div>
    <app-results id="resultsPage" [pollId]="pollId" [displayIndex]="displayIndex" [pollData]="pollData"
      [assessorsValidated]="assessorsValidated" (sendAssessorsList)="getRemainingAssessors()"
      [hasAssessors]="hasAssessors" (sendAssessorsInvitation)="relaunchAssessors()"
      [canResendAssessors]="canResendAssessors" [isActive]="isActive" [remainingAssessorTime]="remainingAssessorTime"
      [endDateFormat]="endDateFormat" [assessorCount]="assessors" [inactiveAssessorCount]="remainingAssessors">
    </app-results>
  </div>
</div>
<div *ngIf="isError">
  <app-error (isClosed)="common.navigateToPolls()" [errorMessage]="errorMessage">
  </app-error>
</div>
<vc-warning-popup *ngIf="shouldDisplaySharePopup" title="{{'OFFERS.WARNING.CATCH' | translate}}"
  firstText="{{'POLL-WARNING.SHARE-POPUP' | translate}}" [confirmButton]="true"
  (endDetailsPopup)="dismissSharePopup($event)">
</vc-warning-popup>
<div *ngIf="isSending">
  <vc-loader messageToTheUser="{{'LOADER.SHARE-RESULT' | translate}}">
  </vc-loader>
</div>
<div *ngIf="displayAssessorPopup">
  <assessors-list-popup (endDetailsPopup)="dismissAssessorsPopup()" [mails]="inactiveAssessors"></assessors-list-popup>
</div>
<!-- <div *ngIf="shouldAssessorConvocationWarning">
  <assessors-relaunch-popup (isClosed)="launchAssessorsRelaunch($event)" [isResend]=false [isAssessors]=true>
  </assessors-relaunch-popup>
</div> -->
<div *ngIf="displayVoterStatus != ''">
  <vc-warning-popup title="{{votersTitle}}" [mails]="displayedVoters" [understoodEndButton]="true"
    (endDetailsPopup)="dismissVoters()" [separator]="false">
  </vc-warning-popup>
</div>
<div *ngIf="representativePopup">
  <representative-popup (endDetailsPopup)="representativePopup = false"
    [representationData]="representationData[0]"></representative-popup>
</div>
